import { render, staticRenderFns } from "./ModelCategory.vue?vue&type=template&id=158d20b8&scoped=true"
import script from "./ModelCategory.vue?vue&type=script&lang=js"
export * from "./ModelCategory.vue?vue&type=script&lang=js"
import style0 from "./ModelCategory.vue?vue&type=style&index=0&id=158d20b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d20b8",
  null
  
)

export default component.exports